import { Link } from "react-router-dom";
import { featuredVideos } from "@/mocks/media";

export default function VideoWorks() {
  return (
    <section className="py-16 bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              影视作品
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">经典影视作品回顾</p>
          </div>
          <Link
            to="/category/drama"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to="/category/drama"
              className="group rounded-lg border border-background-200/70 hover:border-background-300 overflow-hidden bg-background-50 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={video.imageUrl}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={video.title}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/80 text-foreground-950 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {video.role} &middot; {video.year}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}